(() => {
  'use strict';

  const formatMoney = (cents, format) => {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    const value = Number(cents || 0);
    const placeholder = /\{\{\s*(\w+)\s*\}\}/;
    const moneyFormat = format || '${{amount}}';
    const withDelimiters = (number, precision = 2, thousands = ',', decimal = '.') => {
      if (Number.isNaN(number) || number == null) return '0';
      const parts = (number / 100).toFixed(precision).split('.');
      parts[0] = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, `$1${thousands}`);
      return parts[1] ? parts.join(decimal) : parts[0];
    };
    const match = moneyFormat.match(placeholder);
    const token = match ? match[1] : 'amount';
    let output = '';
    switch (token) {
      case 'amount_no_decimals':
        output = withDelimiters(value, 0);
        break;
      case 'amount_with_comma_separator':
        output = withDelimiters(value, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        output = withDelimiters(value, 0, '.', ',');
        break;
      default:
        output = withDelimiters(value, 2);
    }
    return moneyFormat.replace(placeholder, output);
  };

  const announce = (message) => {
    const liveRegion = document.getElementById('WrLiveRegion');
    if (!liveRegion) return;
    liveRegion.textContent = '';
    window.setTimeout(() => { liveRegion.textContent = message; }, 50);
  };

  document.querySelectorAll('[data-mobile-menu]').forEach((menu) => {
    menu.addEventListener('toggle', () => {
      document.body.classList.toggle('no-scroll', menu.open);
    });
  });

  document.querySelectorAll('[data-quantity]').forEach((quantity) => {
    const input = quantity.querySelector('input[type="number"]');
    if (!input) return;
    quantity.querySelectorAll('button').forEach((button) => {
      button.addEventListener('click', () => {
        const current = parseInt(input.value, 10) || 1;
        const next = button.dataset.action === 'increase' ? current + 1 : Math.max(1, current - 1);
        input.value = next;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });

  document.querySelectorAll('[data-product-root]').forEach((root) => {
    const variantsNode = root.querySelector('[data-product-variants]');
    const form = root.querySelector('form[action*="/cart/add"]');
    if (!variantsNode || !form) return;

    let variants = [];
    try { variants = JSON.parse(variantsNode.textContent); } catch (error) { return; }

    const optionInputs = [...root.querySelectorAll('[data-option-select]')];
    const variantInput = form.querySelector('input[name="id"]');
    const price = root.querySelector('[data-product-price]');
    const comparePrice = root.querySelector('[data-product-compare-price]');
    const submit = form.querySelector('[data-add-to-cart]');
    const submitText = submit ? submit.querySelector('[data-add-to-cart-text]') : null;

    const updateVariant = () => {
      const selectedOptions = optionInputs.map((input) => input.value);
      const variant = variants.find((item) =>
        item.options.every((option, index) => option === selectedOptions[index])
      );

      if (!variant) {
        if (variantInput) variantInput.value = '';
        if (submit) submit.disabled = true;
        if (submitText) submitText.textContent = 'Unavailable';
        return;
      }

      if (variantInput) variantInput.value = variant.id;
      if (price) price.textContent = formatMoney(variant.price, window.wyldRose?.moneyFormat);
      if (comparePrice) {
        comparePrice.textContent = variant.compare_at_price > variant.price
          ? formatMoney(variant.compare_at_price, window.wyldRose?.moneyFormat)
          : '';
        comparePrice.hidden = !(variant.compare_at_price > variant.price);
      }
      if (submit) submit.disabled = !variant.available;
      if (submitText) submitText.textContent = variant.available ? 'Add to bag' : 'Sold out';

      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    };

    optionInputs.forEach((input) => input.addEventListener('change', updateVariant));
  });

  document.querySelectorAll('[data-sort-by]').forEach((select) => {
    select.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      window.location.assign(url.toString());
    });
  });

  document.querySelectorAll('[data-auto-submit]').forEach((input) => {
    input.addEventListener('change', () => input.form?.submit());
  });

  document.addEventListener('shopify:section:load', () => {
    announce('Section updated');
  });

  window.WyldRose = { formatMoney, announce };
})();
